// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"9c532a09","267":"bd9303c2","346":"cfd24764","358":"d54365c9","465":"1b74cf0e","504":"c6381f0a","506":"18aeb48e"}[chunkId] + ".chunk.js";
};